import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, SCREEN_PADDING_LARGE, TYPOGRAPHY } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

interface Props {
  showListView: boolean;
  style?: StyleProp<ViewStyle>;
}

export const PAID_SEARCH_BORDER_WIDTH = 4;

export const PaidSearchItemHeader: React.FC<Props> = ({
  style,
  showListView,
}) => {
  const [styles] = useStyles();

  return (
    <View style={[styles.base, showListView ? styles.baseList : null, style]}>
      <View style={styles.featuredContainer}>
        <Text style={[TYPOGRAPHY.tabBarLabel, styles.featuredText]}>
          {i18n.t('featured')}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'flex-end',
    borderBottomColor: theme.colors.accent,
    borderBottomWidth: PAID_SEARCH_BORDER_WIDTH,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  baseList: {
    marginHorizontal: SCREEN_PADDING_LARGE,
  },
  featuredContainer: {
    backgroundColor: theme.colors.accent,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    paddingHorizontal: 8,
    paddingTop: 4,
  },
  featuredText: {
    ...FONTS.primaryBold,
    color: theme.colors.accentLight,
    marginBottom: -1,
    textTransform: 'uppercase',
  },
}));
